import { ListProcessingStatus } from "@/enum/list.enum";

export type ProcessingStatusTone = "in-progress" | "warning" | "neutral";

export interface ProcessingStatusPill {
	tone: ProcessingStatusTone;
	/** i18n key under `dashboard.newLeads.status.*` */
	labelKey: string;
}

// Per the dashboard brief (Suggested UI §3): active processing states read as
// "in progress", failure/blocked states as "warning", and idle/finished as neutral.
const IN_PROGRESS_STATUSES: ReadonlyArray<ListProcessingStatus> = [
	ListProcessingStatus.PROCESSING,
	ListProcessingStatus.WAITING,
	ListProcessingStatus.API_WAITING,
	ListProcessingStatus.WAITING_FOR_SESSION,
	ListProcessingStatus.DESKTOP_APP,
];

const WARNING_STATUSES: ReadonlyArray<ListProcessingStatus> = [
	ListProcessingStatus.ERROR,
	ListProcessingStatus.NOT_ENOUGH_CREDITS,
	ListProcessingStatus.NO_USER_FOUND,
];

export const processingStatusTone = (status: ListProcessingStatus): ProcessingStatusTone => {
	if (IN_PROGRESS_STATUSES.includes(status)) {
		return "in-progress";
	}

	if (WARNING_STATUSES.includes(status)) {
		return "warning";
	}

	return "neutral";
};

export const processingStatusPill = (status: ListProcessingStatus): ProcessingStatusPill => ({
	tone: processingStatusTone(status),
	labelKey: `dashboard.newLeads.status.${status}`,
});

// Semantic Tailwind tokens from tailwind.config.js — no raw palette colors.
export const PROCESSING_TONE_CLASSES: Record<ProcessingStatusTone, string> = {
	"in-progress": "bg-action-200 text-brand-light",
	warning: "bg-status-warning-light text-text-warning",
	neutral: "bg-background-light text-text-meta",
};
